import styled from 'styled-components';

export default styled.div`
  button {
    font-size: initial;
    padding: 0;
  }
  .buttonContainer {
    margin-top: 50px;
    .btn {
      margin: 0 1em;
    }
  }
  .successMac {
    p {
      color: #1e1e1e;
    }
  }
  .successMobile {
    .squareButton {
      margin-top: 50px;
    }
  }
  .alternateDownload {
    margin-top: 30px;
    text-align: center;
    a {
      font-size: 0.8em;
    }
  }
`;
